import React from "react";
import "swiper/css";
import { ThreeDCardDemo } from "../MagicUi/CardEffect/ThreeDCardDemo";
import { OurClientTallyserverLogop } from "./OurClientTallyserverLogop";

export default function OurClientTallyserver() {
  return (
    <section className="pb50 pt115 OurClient text-center OurClientTallyserverLogop">
      <div className="container">
        <div className="titletwo">
          <h2>
            Our clients using <span>Tally Server</span>
          </h2>
        </div>
        <div className="clients-main">
          {OurClientTallyserverLogop.map((OurClientTallyserverLogop) => (
            <ThreeDCardDemo
              key={OurClientTallyserverLogop.id}
              data-aos-anchor-placement="center-bottom"
              imgtag={OurClientTallyserverLogop.img}
              imgtitle={OurClientTallyserverLogop.alt}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
